module.exports = __webpack_public_path__ + "img/loading-ready-vector@3x.4bf11989.png";